<!--<div class="db-demo-blk-offer" *ngIf="!paidFeature">
  <p>30% off your first payment – Black Friday special! <span>Exclusive holiday offer ends soon.</span></p>
</div>-->

<div class="with-scroll">
<div class="db-one-week-free-demo">
  <div class="db-one-week-free-demo__header">
    <div>
      <div class="back" (click)="onStepChange.emit('features')" *ngIf="showBackButton"><i
        class="db-icon db-icon-ds-arrow-small"></i></div>
      <!--<h1 class="mb35" *ngIf="paidFeature">Get 10Web Pro plans</h1>
      <h1 class="mb35" *ngIf="!paidFeature">Try 10Web Pro plans for <br *ngIf="!!isMobile"/>free for 7 days</h1>-->
      <h1 class="mb12" *ngIf="paidFeature">Get 10Web Pro Plan with <span
        class="with-gradient">a free custom domain</span></h1>
      <h1 class="mb12" *ngIf="!paidFeature">Get 7 days of 10Web Pro Plans and a custom domain for Free</h1>
    </div>
    <div class="db-tabs-with-period-switch">
      <div class="db-pricing-tabs">
        <div class="db-tab" [ngClass]="{'db-active': activeTab === 'business'}"
             *ngIf="(currentSubscription?.trialClient  ||
             [UserSubscriptionType?.PLATFORM, UserSubscriptionType?.DEDICATEDVM].includes(currentSubscription?.type)) && !(currentSubscription.trialClient && isEcommerceWebsite) && !hideTab"
             (click)="openTab('business')">
          <span>Business</span></div>
        <div class="db-tab" [ngClass]="{'db-active': activeTab === 'ecommerce'}"
             *ngIf=" (currentSubscription?.trialClient || [UserSubscriptionType?.PLATFORM, UserSubscriptionType?.DEDICATEDVM].includes(currentSubscription?.type))"
             (click)="openTab('ecommerce')">
          <span>Ecommerce</span></div>

        <div class="db-tab" [ngClass]="{'db-active': activeTab === 'agency'}"
             *ngIf="(currentSubscription?.trialClient || [UserSubscriptionType?.PLATFORM, UserSubscriptionType?.DEDICATEDVM].includes(currentSubscription?.type))"
             (click)="openTab('agency')">
          <span>Agency <span *ngIf="!isMobile">(2+ websites)</span></span></div>
      </div>
      <div class="db-period-switch-coupon db-upgrade-plan__period-switch mb8" *ngIf="!isMobile">
        <db-pricing-period-switcher
          [dontChangeSwitchValue]="true"
          [fromPopup]="true"
          [user]="user" [formControl]="periodSwitch"
          [currentSubscription]="currentSubscription"
          [uppercaseTitle]="false" [small]="true"></db-pricing-period-switcher>
      </div>
    </div>
  </div>
  <div class="db-one-week-free-demo__container">
    <div class="db-period-switch-coupon db-upgrade-plan__period-switch mb8 mt20" *ngIf="!!isMobile">
      <db-pricing-period-switcher
        [fromPopup]="true"
        [dontChangeSwitchValue]="true"
        [user]="user" [formControl]="periodSwitch"
        [currentSubscription]="currentSubscription"
        [uppercaseTitle]="false"
        [isMobile]="true"
      ></db-pricing-period-switcher>
    </div>
    <div class="db-one-week-free-demo__content {{activeTab}}">
      {{couponCode}}
      <div class="db-divider" *ngIf="['agency', 'ecommerce'].includes(activeTab)"></div>
      <ng-container *ngIf="subscriptionsTabs && subscriptionsTabs[activeTab]">
        <ng-container *ngFor="let subscription of subscriptionsTabs[activeTab], let i = index">
          <db-one-week-free-demo-option
            [isEcommerceWebsite]="isEcommerceWebsite"
            [ngClass]="{'hidden': subscription?.plan?.periodNumber !== periodSwitch?.value, 'visible': subscription?.plan?.periodNumber === periodSwitch?.value, 'last-child': i === subscriptionsTabs[activeTab].length - 1}"
            [title]="subscription?.plan?.title"
            [applyCouponForPlatform]="applyCouponForPlatform"
            [couponPercent]="couponPercent"
            [domainName]="domainName"
            [hasFreeDays]="hasFreeDays"
            [description]="planFeatures[activeTab][subscription?.category]?.desc"
            [subscription]="subscription"
            [periodSwitchValue]="periodSwitch?.value"
            [paidFeature]="paidFeature"
            [plan]="planFeatures[activeTab][subscription?.category]?.planInfo"
            [planDesc]="planFeatures[activeTab][subscription?.category]?.planInfoDesc"
            [mostPopular]="!!planFeatures[activeTab][subscription?.category]?.mostPopular"
            [professionalInfo]="!!planFeatures[activeTab][subscription?.category]?.info"
            [isAgency]="activeTab === 'agency'"
            [activeTab]="activeTab"
            [customDomainFlow]="customDomainFlow"
            (onStepChange)="chooseSubscr(subscription, subscription.couponCode); onStepChange.emit('checkout'); resizeToNormal()"
          ></db-one-week-free-demo-option>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
</div>
